/* Campaign-only bundle cart flow. Sends the four included items in one request. */
(() => {
  function startBundle() {
    const bundle = document.querySelector('[data-apology-bundle]');
    const note = document.querySelector('[data-bundle-gift-note]');
    const error = document.querySelector('[data-bundle-cart-error]');
    const addButton = document.querySelector('[data-apology-bundle-add]');
    const addButtonLabel = addButton?.querySelector('[data-apology-bundle-add-label]');
    const secondaryNote = document.querySelector('[data-bundle-gift-note-secondary]');
    const secondaryNoteConfirm = document.querySelector('[data-bundle-gift-note-confirm]');
    const secondaryNoteStatus = document.querySelector('[data-bundle-gift-note-status]');

    if (!bundle || !note || !error || !addButton) {
      console.warn('Bundle initialization paused: required campaign fields were not found.');
      return;
    }

    // The lower journey field is an optional second entrance to the same gift
    // note. Keep both values synchronized so the shopper never has to repeat a
    // message and the cart logic can continue reading one canonical field.
    if (secondaryNote) {
      secondaryNote.value = note.value;
      let noteSyncInProgress = false;
      const resetSecondaryConfirmation = () => {
        if (secondaryNoteConfirm) {
          secondaryNoteConfirm.classList.remove('is-confirmed');
          secondaryNoteConfirm.textContent = 'Use this message';
        }
        if (secondaryNoteStatus) secondaryNoteStatus.textContent = '';
      };
      const syncNote = (source, target) => {
        if (noteSyncInProgress || target.value === source.value) return;
        noteSyncInProgress = true;
        target.value = source.value;
        noteSyncInProgress = false;
      };
      note.addEventListener('input', () => {
        syncNote(note, secondaryNote);
        resetSecondaryConfirmation();
      });
      secondaryNote.addEventListener('input', () => {
        syncNote(secondaryNote, note);
        resetSecondaryConfirmation();
      });
      secondaryNoteConfirm?.addEventListener('click', () => {
        const message = secondaryNote.value.trim();
        if (!message) {
          if (secondaryNoteStatus) secondaryNoteStatus.textContent = 'Write your message first.';
          secondaryNote.focus();
          return;
        }
        syncNote(secondaryNote, note);
        secondaryNoteConfirm.classList.add('is-confirmed');
        secondaryNoteConfirm.textContent = 'Message ready ✓';
        if (secondaryNoteStatus) {
          secondaryNoteStatus.textContent = 'It will be included when you add the set to your cart.';
        }
      });
    }

    // Reuse the already uploaded transparent Gift Wrap render as a small,
    // decorative product cue on the optional-message field. The textarea,
    // its label and all form behavior remain unchanged.
    if (!note.closest('.apology-bundle__note-field')) {
      const noteField = document.createElement('div');
      noteField.className = 'apology-bundle__note-field';
      note.parentNode.insertBefore(noteField, note);
      noteField.appendChild(note);

      const giftIcon = document.createElement('span');
      giftIcon.className = 'apology-bundle__note-gift-icon';
      giftIcon.setAttribute('aria-hidden', 'true');
      const giftImage = document.createElement('img');
      giftImage.src = 'https://cdn.shopify.com/s/files/1/0030/3670/8964/files/a-clean-slate-bundle-gift-wrap.webp?v=1788035238';
      giftImage.alt = '';
      giftImage.width = 1500;
      giftImage.height = 1500;
      giftImage.loading = 'lazy';
      giftImage.decoding = 'async';
      giftIcon.appendChild(giftImage);
      noteField.appendChild(giftIcon);

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let giftIconFrame;
        const updateGiftIconParallax = () => {
          giftIconFrame = undefined;
          const rect = giftIcon.getBoundingClientRect();
          const currentShift = Number.parseFloat(giftIcon.style.getPropertyValue('--apology-note-icon-y') || '0');
          const naturalCenter = rect.top - currentShift + rect.height / 2;
          const distance = (naturalCenter - window.innerHeight / 2) / Math.max(window.innerHeight, 1);
          const progress = Math.max(-1, Math.min(1, distance * 1.35));
          giftIcon.style.setProperty('--apology-note-icon-y', `${(progress * 5).toFixed(2)}px`);
        };
        const requestGiftIconParallax = () => {
          if (!giftIconFrame) giftIconFrame = window.requestAnimationFrame(updateGiftIconParallax);
        };
        window.addEventListener('scroll', requestGiftIconParallax, { passive: true });
        window.addEventListener('resize', requestGiftIconParallax, { passive: true });
      }
    }

    // The fallback locks the corrected campaign to its approved 14K White Gold
    // / Luxury Box variant, even before the template's data attribute is read.
    const mainVariantId = bundle.dataset.mainVariantId || '58569543319816';
    const earringsVariantId = bundle.dataset.earringsVariantId;
    const giftWrapVariantId = bundle.dataset.giftWrapVariantId;
    const giftBagVariantId = bundle.dataset.giftBagVariantId;
    const giftWrapHandle = bundle.dataset.giftWrapHandle;
    const parentTitle = bundle.dataset.parentTitle;

    if (!mainVariantId || !earringsVariantId || !giftWrapVariantId || !giftBagVariantId || !giftWrapHandle || !parentTitle) {
      console.warn('Bundle initialization paused: campaign item IDs are incomplete.');
      return;
    }

    // The store's Zipify Cart Drawer captures regular product Add-to-cart controls
    // during document capture. Excluding this isolated campaign button ensures its
    // single three-item cart request is not replaced with the parent-product request.
    if (window.Zipify?.Cart?.api) {
      window.Zipify.Cart.api.excludeActionButton = '[data-apology-bundle-add]';
    }

    const setError = (message = '') => {
      error.textContent = message;
      error.hidden = !message;
    };

    const setLoading = (loading) => {
      addButton.disabled = loading;
      addButton.setAttribute('aria-busy', loading ? 'true' : 'false');
      if (addButtonLabel) {
        addButtonLabel.textContent = loading ? 'Adding bundle…' : 'Add bundle to cart';
      } else {
        addButton.textContent = loading ? 'Adding bundle…' : 'Add bundle to cart';
      }
    };

    const addCompleteSet = async () => {
      if (addButton.dataset.bundleProcessing === 'true') {
        return;
      }
      setError('');
      const quantity = 1;
      const message = note.value.trim();
      const mainProperties = {
        '_apology_bundle': 'apology-luxury-box-2026',
        '_Addon | Assigned with': giftWrapVariantId,
        '_Addon | handle': giftWrapHandle
      };
      const giftWrapProperties = {
        '_apology_bundle': 'apology-luxury-box-2026',
        '_Addon | Assigned to': parentTitle
      };
      const earringsProperties = {
        '_apology_bundle': 'apology-luxury-box-2026'
      };
      const giftBagProperties = {
        '_apology_bundle': 'apology-luxury-box-2026',
        '_Addon | Assigned to': parentTitle
      };

      // Mirror ShineOn's official Gift Wrap line-item properties only when a
      // buyer has entered a note. A blank message is valid and needs no property.
      if (message) {
        mainProperties._gift_note = message;
        mainProperties._gift_note_variant_id = giftWrapVariantId;
        giftWrapProperties['Gift note'] = message;
        giftWrapProperties._gift_note = message;
        giftWrapProperties._gift_note_variant_id = giftWrapVariantId;
      }

      setLoading(true);
      addButton.dataset.bundleProcessing = 'true';
      try {
        const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        const response = await fetch(`${cartAddUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              { id: mainVariantId, quantity, properties: mainProperties },
              { id: earringsVariantId, quantity, properties: earringsProperties },
              { id: giftWrapVariantId, quantity, properties: giftWrapProperties },
              { id: giftBagVariantId, quantity, properties: giftBagProperties }
            ]
          })
        });

        if (!response.ok) {
          const responseBody = await response.json().catch(() => ({}));
          throw new Error(responseBody.description || responseBody.message || 'The set could not be added to cart.');
        }

        document.dispatchEvent(new CustomEvent('apology:bundle-added'));

        // Keep shoppers on the campaign page and open Zipify's live drawer.
        // The redirect is retained only as a fallback if Zipify is unavailable.
        if (typeof window.OPEN_CART === 'function') {
          window.OPEN_CART({ triggerElement: addButton });
          setLoading(false);
          delete addButton.dataset.bundleProcessing;
        } else {
          window.location.assign('/cart');
        }
      } catch (exception) {
        setError(exception.message || 'The set could not be added to cart. Please try again.');
        setLoading(false);
        delete addButton.dataset.bundleProcessing;
      }
    };

    // Do not add the set on pointer-down: that made a finger starting a page scroll
    // over the CTA behave as a purchase. A normal tap must end within the threshold;
    // a scroll or drag cancels the action completely.
    let pointerStart;
    let suppressNextClick = false;
    const TAP_DISTANCE_PX = 12;

    addButton.addEventListener('pointerdown', (event) => {
      pointerStart = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        moved: false
      };
    });
    addButton.addEventListener('pointermove', (event) => {
      if (!pointerStart || pointerStart.id !== event.pointerId) return;
      const distance = Math.hypot(event.clientX - pointerStart.x, event.clientY - pointerStart.y);
      if (distance > TAP_DISTANCE_PX) pointerStart.moved = true;
    });
    addButton.addEventListener('pointercancel', () => { pointerStart = undefined; });
    addButton.addEventListener('pointerup', (event) => {
      if (!pointerStart || pointerStart.id !== event.pointerId) return;
      const shouldAdd = !pointerStart.moved;
      pointerStart = undefined;
      if (!shouldAdd) return;
      event.preventDefault();
      event.stopPropagation();
      suppressNextClick = true;
      addCompleteSet();
      window.setTimeout(() => { suppressNextClick = false; }, 450);
    });

    // Preserve keyboard accessibility. The click listener remains a fallback for
    // browsers that do not expose Pointer Events.
    addButton.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        addCompleteSet();
      }
    });
    addButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (suppressNextClick) return;
      addCompleteSet();
    });
  }

  function startMobileGalleryControls() {
    const mediaWrapper = document.querySelector('.product__media-wrapper');
    const mediaList = mediaWrapper?.querySelector('.product__media-list.slider--mobile');
    if (!mediaWrapper || !mediaList || mediaWrapper.querySelector('.apology-gallery-arrow')) return;

    const mediaItems = Array.from(mediaList.querySelectorAll('.product__media-item'));
    if (mediaItems.length < 2) return;

    const createArrow = (direction, label) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `apology-gallery-arrow apology-gallery-arrow--${direction}`;
      button.setAttribute('aria-label', label);
      return button;
    };

    const previousButton = createArrow('previous', 'Previous product image');
    const nextButton = createArrow('next', 'Next product image');
    mediaWrapper.append(previousButton, nextButton);

    const getActiveIndex = () => {
      const listCenter = mediaList.scrollLeft + mediaList.clientWidth / 2;
      return mediaItems.reduce((closestIndex, item, index) => {
        const itemCenter = item.offsetLeft + item.offsetWidth / 2;
        const closestItem = mediaItems[closestIndex];
        const closestCenter = closestItem.offsetLeft + closestItem.offsetWidth / 2;
        return Math.abs(itemCenter - listCenter) < Math.abs(closestCenter - listCenter) ? index : closestIndex;
      }, 0);
    };

    const updateArrowState = () => {
      const activeIndex = getActiveIndex();
      previousButton.disabled = activeIndex === 0;
      nextButton.disabled = activeIndex === mediaItems.length - 1;
    };

    const showImage = (direction) => {
      const targetIndex = Math.max(0, Math.min(mediaItems.length - 1, getActiveIndex() + direction));
      const target = mediaItems[targetIndex];
      mediaList.scrollTo({
        left: target.offsetLeft - (mediaList.clientWidth - target.offsetWidth) / 2,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    };

    previousButton.addEventListener('click', () => showImage(-1));
    nextButton.addEventListener('click', () => showImage(1));

    let galleryFrame;
    mediaList.addEventListener('scroll', () => {
      if (galleryFrame) window.cancelAnimationFrame(galleryFrame);
      galleryFrame = window.requestAnimationFrame(() => {
        galleryFrame = undefined;
        updateArrowState();
      });
    }, { passive: true });
    window.addEventListener('resize', updateArrowState, { passive: true });
    updateArrowState();
  }

  function startStickyCart() {
    const addButton = document.querySelector('[data-apology-bundle-add]');
    if (!addButton || document.querySelector('.apology-sticky-cart')) return;

    const stickyButton = document.createElement('button');
    const price = document.querySelector('.apology-bundle__price')?.textContent?.trim();
    stickyButton.type = 'button';
    stickyButton.className = 'apology-sticky-cart';
    stickyButton.setAttribute('aria-label', price ? `Add bundle to cart, ${price}` : 'Add bundle to cart');
    const stickyLabel = document.createElement('span');
    stickyLabel.textContent = 'Add bundle to cart';
    stickyButton.append(stickyLabel);
    if (price) {
      const stickyPrice = document.createElement('span');
      stickyPrice.className = 'apology-sticky-cart__price';
      stickyPrice.textContent = price;
      stickyButton.append(stickyPrice);
    }
    document.body.append(stickyButton);

    const setVisible = (visible) => {
      stickyButton.classList.toggle('is-visible', visible);
      stickyButton.setAttribute('aria-hidden', visible ? 'false' : 'true');
      stickyButton.tabIndex = visible ? 0 : -1;
    };

    const updateStickyState = () => {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const hasPassedMainButton = addButton.getBoundingClientRect().bottom < 0;
      setVisible(isMobile && hasPassedMainButton);
      stickyButton.disabled = addButton.disabled;
      stickyButton.setAttribute('aria-busy', addButton.getAttribute('aria-busy') || 'false');
    };

    stickyButton.addEventListener('click', () => {
      if (!addButton.disabled) addButton.click();
    });

    const buttonObserver = new MutationObserver(updateStickyState);
    buttonObserver.observe(addButton, { attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
    window.addEventListener('scroll', updateStickyState, { passive: true });
    window.addEventListener('resize', updateStickyState, { passive: true });
    updateStickyState();
  }

  // Reveal each inclusion node only when the visitor reaches it. CSS attaches
  // the one-time spotlight bloom and champagne glint to this visible state.
  function startJourney() {
    const journey = document.querySelector('[data-apology-journey]');
    if (!journey) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const nodes = Array.from(journey.querySelectorAll('[data-apology-step]'));
    const revealRoute = (route) => {
      route.classList.add('is-visible');
    };
    const revealNode = (node) => {
      const wasVisible = node.classList.contains('is-visible');
      node.classList.add('is-visible');
      if (!wasVisible && !reduceMotion.matches) {
        // Desktop's whole-card parallax takes over after the reveal settles.
        // Mobile image offsets are calculated continuously further below.
        window.setTimeout(() => {
          node.classList.add('is-parallax-ready');
          requestParallax();
        }, 720);
      }
      const step = Number.parseInt(node.dataset.apologyStep || '0', 10);
      if (step > 1) {
        journey.querySelectorAll(`[data-apology-route-step="${step - 1}"]`)
          .forEach(revealRoute);
      }
    };
    const revealAll = () => {
      nodes.forEach(revealNode);
      journey.querySelectorAll('[data-apology-route-step]').forEach(revealRoute);
    };

    // Build the three connector paths from the actual rendered card positions.
    // This replaces fixed SVG coordinates, so the route remains offset and
    // intentional at every desktop, tablet and mobile width.
    const canvas = journey.querySelector('.apology-journey__canvas');
    const routeSvg = journey.querySelector('.apology-journey__route');
    // Connector artwork has been retired. Keeping this empty also makes all
    // legacy route helpers below immediate no-ops for older template markup.
    const routes = [];
    const routeLayers = routes.map((route, index) => {
      route.classList.add('apology-journey__route-line--glow');
      const ribbon = route.cloneNode(false);
      const core = route.cloneNode(false);
      [ribbon, core].forEach((layer) => layer.removeAttribute('data-apology-route-step'));
      ribbon.classList.remove('apology-journey__route-line--glow');
      ribbon.classList.add('apology-journey__route-line--ribbon');
      core.classList.remove('apology-journey__route-line--glow');
      core.classList.add('apology-journey__route-line--core');
      core.style.animationDelay = `${index * -.85}s`;
      route.parentNode.insertBefore(ribbon, route.nextSibling);
      route.parentNode.insertBefore(core, ribbon.nextSibling);
      return [route, ribbon, core];
    });
    const setRoutePath = (index, path) => {
      routeLayers[index]?.forEach((layer) => layer.setAttribute('d', path));
    };
    const refreshRoutes = () => {
      if (!canvas || !routeSvg || routes.length !== 3 || nodes.length < 4) return;
      const canvasRect = canvas.getBoundingClientRect();
      if (!canvasRect.width || !canvasRect.height) return;
      routeSvg.setAttribute('viewBox', `0 0 ${canvasRect.width} ${canvasRect.height}`);
      const isMobile = window.matchMedia('(max-width: 749px)').matches;

      routes.forEach((route, index) => {
        const from = nodes[index].querySelector('.apology-journey__image-wrap')?.getBoundingClientRect();
        const to = nodes[index + 1].querySelector('.apology-journey__image-wrap')?.getBoundingClientRect();
        if (!from || !to) return;

        if (isMobile) {
          // The mobile beam follows a broad S-curve through the open space
          // between the stacked image-and-copy groups. It stays behind both.
          const fromNode = nodes[index];
          const toNode = nodes[index + 1];
          const fromArrowShift = Number.parseFloat(fromNode.style.getPropertyValue('--apology-arrow-parallax-y') || '0');
          const toArrowShift = Number.parseFloat(toNode.style.getPropertyValue('--apology-arrow-parallax-y') || '0');
          const routePreset = [
            { start: .72, end: .26, first: .18, second: .82 },
            { start: .28, end: .76, first: .82, second: .16 },
            { start: .70, end: .34, first: .20, second: .78 }
          ][index];
          const x1 = from.left - canvasRect.left + from.width * routePreset.start;
          const y1 = from.top - canvasRect.top + from.height * .70 + fromArrowShift;
          const x2 = to.left - canvasRect.left + to.width * routePreset.end;
          const y2 = to.top - canvasRect.top + to.height * .28 + toArrowShift;
          const travel = Math.max(80, y2 - y1);
          const waveX1 = canvasRect.width * routePreset.first;
          const waveX2 = canvasRect.width * routePreset.second;
          const waveY1 = y1 + travel * .34;
          const waveY2 = y1 + travel * .68;
          const mobilePath = [
            `M ${x1.toFixed(1)} ${y1.toFixed(1)}`,
            `C ${x1.toFixed(1)} ${(y1 + travel * .14).toFixed(1)} ${waveX1.toFixed(1)} ${(waveY1 - travel * .12).toFixed(1)} ${waveX1.toFixed(1)} ${waveY1.toFixed(1)}`,
            `C ${waveX1.toFixed(1)} ${(waveY1 + travel * .13).toFixed(1)} ${waveX2.toFixed(1)} ${(waveY2 - travel * .13).toFixed(1)} ${waveX2.toFixed(1)} ${waveY2.toFixed(1)}`,
            `C ${waveX2.toFixed(1)} ${(waveY2 + travel * .13).toFixed(1)} ${x2.toFixed(1)} ${(y2 - travel * .14).toFixed(1)} ${x2.toFixed(1)} ${y2.toFixed(1)}`
          ].join(' ');
          setRoutePath(index, mobilePath);
          return;
        }

        const travelsRight = to.left > from.left;
        const desktopPreset = [
          { startY: .62, endY: .27, spine: -.045 },
          { startY: .72, endY: .34, spine: .035 },
          { startY: .64, endY: .24, spine: -.025 }
        ][index];
        const startInset = [14, 26, 18][index];
        const endInset = [38, 26, 42][index];
        const x1 = (travelsRight ? from.right - startInset : from.left + startInset) - canvasRect.left;
        const y1 = from.top - canvasRect.top + from.height * desktopPreset.startY;
        const x2 = (travelsRight ? to.left + endInset : to.right - endInset) - canvasRect.left;
        const y2 = to.top - canvasRect.top + to.height * desktopPreset.endY;
        const approach = travelsRight ? 46 : -46;
        const travel = Math.max(140, y2 - y1);
        const centerPull = canvasRect.width * desktopPreset.spine;
        const desktopPath = `M ${x1.toFixed(1)} ${y1.toFixed(1)} C ${(x1 + approach + centerPull).toFixed(1)} ${(y1 + travel * .34).toFixed(1)} ${(x2 - approach + centerPull).toFixed(1)} ${(y2 - travel * .34).toFixed(1)} ${x2.toFixed(1)} ${y2.toFixed(1)}`;
        setRoutePath(index, desktopPath);
      });
    };

    if (reduceMotion.matches) {
      revealAll();
      refreshRoutes();
      return;
    }

    // Progressive enhancement: content remains visible before JavaScript adds
    // this class, so the guide never disappears if a browser blocks scripts.
    journey.classList.add('is-ready');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.filter((entry) => entry.isIntersecting).forEach((entry) => {
          revealNode(entry.target);
          observer.unobserve(entry.target);
        });
      }, { threshold: .18, rootMargin: '0px 0px -10% 0px' });
      nodes.forEach((node) => observer.observe(node));
    } else {
      revealAll();
    }

    journey.querySelectorAll('img').forEach((image) => {
      image.addEventListener('load', refreshRoutes, { once: true });
    });

    // Draw once immediately instead of waiting for a scroll-linked animation
    // frame. ResizeObserver keeps the endpoints attached after image loading,
    // orientation changes and responsive Dawn column recalculation.
    refreshRoutes();
    if ('ResizeObserver' in window && canvas && routes.length) {
      const routeResizeObserver = new ResizeObserver(refreshRoutes);
      routeResizeObserver.observe(canvas);
      nodes.forEach((node) => routeResizeObserver.observe(node));
    }

    let frame;
    const setBeamProgress = () => {
      if (!routes.length || nodes.length < 4) return;
      const startLine = window.innerHeight * .84;
      const endLine = window.innerHeight * .38;

      routes.forEach((route, index) => {
        const from = nodes[index].querySelector('.apology-journey__image-wrap')?.getBoundingClientRect();
        const to = nodes[index + 1].querySelector('.apology-journey__image-wrap')?.getBoundingClientRect();
        if (!from || !to) return;
        const fromCenter = from.top + from.height * .62;
        const toCenter = to.top + to.height * .34;
        const span = Math.max(1, toCenter - fromCenter + startLine - endLine);
        const progress = Math.max(0, Math.min(1, (startLine - fromCenter) / span));
        const offset = (1 - progress).toFixed(3);
        const layerOpacity = progress <= 0
          ? [0, 0, 0]
          : [.05 + progress * .17, .07 + progress * .23, .11 + progress * .35];
        routeLayers[index]?.forEach((layer, layerIndex) => {
          layer.style.strokeDashoffset = offset;
          layer.style.opacity = Number(layerOpacity[layerIndex]).toFixed(3);
        });
      });
    };

    const setParallax = () => {
      frame = undefined;
      const viewportCenter = window.innerHeight / 2;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;

      if (isMobile) {
        // Calculate the offset before the reveal finishes, too. This prevents
        // the former 0px -> parallax jump when is-parallax-ready is added.
        // Copy stays fixed, while the smaller safe range avoids visual cropping
        // when the user reverses the scroll direction.
        nodes.forEach((node) => {
          const rect = node.getBoundingClientRect();
          const distance = (rect.top + rect.height / 2 - viewportCenter) / Math.max(window.innerHeight, 1);
          const progress = Math.max(-1, Math.min(1, distance * 1.45));
          node.style.setProperty('--apology-image-parallax-y', `${(progress * 13).toFixed(2)}px`);
          node.style.setProperty('--apology-arrow-parallax-y', `${(progress * 5).toFixed(2)}px`);
        });
        return;
      }

      // Desktop moves each complete inclusion card as one restrained layer.
      nodes.forEach((node) => {
        if (!node.classList.contains('is-parallax-ready')) return;
        const factor = Number.parseFloat(node.dataset.apologyParallax || '0');
        const rect = node.getBoundingClientRect();
        const currentShift = Number.parseFloat(node.style.getPropertyValue('--apology-parallax-y') || '0');
        const naturalCenter = rect.top - currentShift + rect.height / 2;
        const distance = (naturalCenter - viewportCenter) / Math.max(window.innerHeight, 1);
        const maxShift = Math.max(18, factor * 1.8);
        const shift = Math.max(-maxShift, Math.min(maxShift, distance * maxShift * 1.7));
        node.style.setProperty('--apology-parallax-y', `${shift.toFixed(2)}px`);
      });
    };
    const requestParallax = () => {
      if (!frame) frame = window.requestAnimationFrame(setParallax);
    };

    window.addEventListener('scroll', requestParallax, { passive: true });
    window.addEventListener('resize', requestParallax, { passive: true });
    requestParallax();
  }

  if (document.readyState === 'complete') {
    window.setTimeout(() => {
      startBundle();
      startMobileGalleryControls();
      startStickyCart();
      startJourney();
    }, 50);
  } else {
    window.addEventListener('load', () => window.setTimeout(() => {
      startBundle();
      startMobileGalleryControls();
      startStickyCart();
      startJourney();
    }, 50));
  }
})();
